import { KeyboardEvent, MouseEvent, useCallback, useEffect, useRef, useState } from "react"
import Actionbar from "src/components/common/actionbar/Authactionbar"
import { Message } from "src/components/common/form/Message"
import useUiuxStore from "src/store/useUiuxStore"

import { AgGridReact } from "ag-grid-react"
import { InsertRowHandler } from "src/utils/grid/GridHandlerContent"
import { Content_EQM2020_R01 } from "./Content_EQM2020_R01"
import { defaultEQM2020_R01Dto, EQM2020_R01Dto } from "./Dto_EQM2020_R01"
import { EQM2020_R01SearchSection } from "./SearchSection_EQM2020_R01"
import { useEQM2020_R01Store } from "./Store_EQM2020_R01"
import { EQM2020_R01Table } from "./Table_EQM2020_R01"

/**
 * 사용자 관리 컨테이너 컴포넌트
 * 사용자 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_EQM2020_R01 = () => {
	
	const { setMessage } = useUiuxStore();
	const { EQM2020_R01List, } = useEQM2020_R01Store();
	const gridRef = useRef<AgGridReact<EQM2020_R01Dto>>(null);

	// UserContent에서 필요한 핸들러 함수들을 가져옴
	const {
		clickable, setClickable,
		handleExcelClick,
		fetchData,
		defaultEQM2020_R01Row,
		initContainerData,
		handleInsertClick,
		handleSaveClick,
		handleDeleteClick,
		buttonDisabled,
	} = Content_EQM2020_R01({
		gridRef,
		setMessage,
	});
	
	useEffect(() => { 
		if (EQM2020_R01List.length === 0) { handleInsertClick({} as MouseEvent<HTMLButtonElement>); }
	}, [EQM2020_R01List, handleInsertClick]);

	return <div className="content-container">
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		
		<EQM2020_R01SearchSection 
			onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
				if (e.key === 'Enter') {
					fetchData()
				}
			}} 
		/>
		<div className="flex-1 flex">
			<div className="w-full h-full flex flex-col  p-[12px] gap-[12px]">
				
				<EQM2020_R01Table 
					clickable={clickable}				setClickable={setClickable}
					gridRef={gridRef}
					defaultEQM2020_R01Row={defaultEQM2020_R01Row()}
				/>
			</div>
		</div>
		{/* 메시지 표시 컴포넌트 */}
		<Message />
	</div>
}